import React from 'react'

export function POInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        html {
          --po-form-font-size: 0.65em;
        }

        /*DROP DOWN MENU LIKE*/
        .action-btn-menu {
          position: absolute;
          top: 0;
          left: -60px;
          display: flex;
          justify-content: center;
          text-align: center;
          border-radius: 3px;
          font-size: 0.7em;
          z-index: 1;
          display: none;
        }
        .dd-menu { position: relative; }
        .show-dd-menu { display: flex; }

        .pospro-action-btn.edit-row-btn {
          background-color: rgba(0, 255, 0, 1);
          color: whitesmoke;
        }
        .pospro-action-btn.edit-row-btn:hover { background-color: rgba(0, 205, 0, 1); }

        .pospro-action-btn.del-row-btn {
          background-color: rgba(255, 0, 0, 1);
          color: whitesmoke;
        }
        .pospro-action-btn.del-row-btn:hover { background-color: rgba(205, 0, 0, 1); }
        /*DROP DOWN MENU LIKE END*/

        .not-found {
          border: solid 2px red;
          background-color: lightgrey;
          color: darkgrey;
        }

        .not-found:focus {
          background-color: white;
          border: solid 0.5px lightblue;
          color: black;
        }

        .acl-container {
          position: relative;
          text-align: left;
          font-size: 16px;
          font-weight: normal;
        }

        /*.acl-container #autocomplete-list { // this will affect all acl*/
        #name-acl-container #autocomplete-list {
          bottom: 50%;
          margin-bottom: 33px;
        }

        .input-container {
          display: flex;
          flex-direction: column;
        }

        .input-checkbox-container {
          display: flex;
        }
        .input-checkbox-container input {
          margin: auto;
          margin-left: 5px;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function POFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        #add-new-po-header {
          margin: 10px 0;
        }
        #po-form-container {
          /*background-color: blue;*/
          font-size: var(--po-form-font-size);
          padding: 5px;
        }
        .po-form .input-container {
          display: flex;
          flex: 5;
          align-self: center;
        }
        .po-form {
          display: flex;
          margin: 5px;
          justify-content: space-between;
          width: 60%;
        }
        .po-form label {
          /*text-align: right;*/
          font-weight: bold;
          margin-right: 5px;
          padding: 5px;
          /*font-size: var(--po-form-font-size);*/
          flex: 2;
        }
        .po-form input[type='date'] {
          font-family: arial;
        }
        .po-form input {
          padding: 5px;
          border-radius: 3px;
          border: solid 0.5px lightblue;
          /*font-size: var(--po-form-font-size);*/
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function POItemListStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
        {`
          #item-unit-quantity-container {
            border: 1px solid lightgrey;
            display: flex;
            flex-direction: column;
            justify-content: stretch;
            font-size: var(--po-form-font-size);
          }
          #item-unit-quantity-container .table-header th {
            text-align: left;
            padding: 5px;
          }
          #item-unit-quantity-container td {
            padding: 7px;
          }
          #item-unit-quantity-container thead input, select {
            border: solid 1px lightgrey;
          }
          #item-unit-quantity-container th:nth-child(2) {
            width: 50%;
          }
          #item-unit-quantity-container th:nth-child(3) {
            width: 20%;
          }
          #item-unit-quantity-container th:nth-child(4) {
            width: 10%;
          }
          #item-unit-quantity-container th input, select {
            box-sizing: border-box;
            padding: 5px;
            width: 100%;
            height: 33px;
          }
          .highlight-item-details-row {
            background-color: lightblue;
          }
        `}
      </style>
    </React.Fragment>
  )
}
